import React, { useState, useEffect } from 'react';
import { GridWrapper } from '@yme/atoms/grid';
import { IndentWrapper } from '../Separator';
import { VideoPlayerHolder } from './VideoPlayerHolder';
export function Video(props) {
    const [isPlaying, setIsPlaying] = useState(false);
    const [autoPlayValue, setAutoPlayValue] = useState(0);
    const { previewImage, youtubeId, isPlaylistId, isCustomGrid, isRemoveBottomIndent } = props;
    useEffect(() => {
        const autoPlayVal = isPlaying ? 1 : 0;
        if (isPlaying) {
            setAutoPlayValue(autoPlayVal);
        }
    }, [isPlaying]);
    if (!youtubeId) {
        return null;
    }
    if (isCustomGrid) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(GridWrapper, null,
                React.createElement(VideoPlayerHolder, { isPlaying: isPlaying, previewImage: previewImage, autoPlayValue: autoPlayValue, isPlaylistId: isPlaylistId, setIsPlaying: setIsPlaying, youtubeId: youtubeId }))));
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(VideoPlayerHolder, { isPlaying: isPlaying, previewImage: previewImage, autoPlayValue: autoPlayValue, isPlaylistId: isPlaylistId, setIsPlaying: setIsPlaying, youtubeId: youtubeId })));
}
Video.displayName = 'Video_AEMComponent';
